import _ = require("underscore");
import $ = require("jquery");
import template = require("../templates/basemap-template");
import Base = require("./base-view");
import Portal = require("portal-gis");

class BasemapView extends Base<Portal.MapLayerLeaf> {

    static about = `
The app/controls/basemap-tool uses this view to render basemaps.
    `;

    execute(options = this.options) {
        _.defaults(options, {
            className: 'basemap',
            tagName: 'select',
            template: template
        });

        this.events = <any>{
            "change": "onChange"
        };

        return super.execute(options);
    }

    onShow() {
        let value = this.options["default-basemap"];
        if (value) {
            this.$el.prop("value", value);
        } else {
            this.$el.prop("selectedIndex", -1);
        }
    }

    onChange(event, ui) {
        var value = this.$("option:selected").prop("value");
        this.trigger("change", { value: value });
    }
}

export = BasemapView;